import './index.css'

function ScannedSite({ domain, handleClick, status, dateAddedByUser }) {
    let statusClass;

    const now = new Date();
    const addedDate = new Date(dateAddedByUser);
    const diffMs = now - addedDate;
    const diffMinutes = diffMs / (1000 * 60);

    if (status) {
        statusClass = "positive-status";
    } else if (diffMinutes < 5) {
        statusClass = "pending-status";
    } else {
        statusClass = "negative-status";
    }

    return (
        <div className='feed-item-border scanned-site'>
            <div className='feed-item site-scan-holder'>
                <div className='domain-name small-text'>{domain}</div>
                <div className={'status-globule ' + statusClass}>
                    {status ? "Success" : diffMinutes < 5 ? "Pending" : "Failed"}
                </div>
                <img
                    className='delete-button'
                    src='./images/bin.png'
                    alt='delete'
                    onClick={() => { handleClick(domain) }}
                />
            </div>
        </div>
    );
}

export default ScannedSite;